module.exports = __webpack_public_path__ + "img/install_plugin.png";